/**
 * CardClick::createEvent()
 *
 * @param event
 * @param productId
 */
export const CARD_CLICK_EVENT = "card-click-event";
export const createEvent = (event, productId) => {
    event.preventDefault();

    window.dispatchEvent(new CustomEvent(CARD_CLICK_EVENT, {
        detail: {
            event:      event,
            target:     event.target,
            productId:  productId,
        }
    }));
}
